import { FC, useCallback } from 'react';

import { useSelector } from 'react-redux';
import { DropdownFilter, DropdownPrice, useDropdown } from 'shared/components/DropdownFilter';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { FILTER_KEY } from './constants';
import { selectPriceFilter, selectPriceTypeAvailable } from 'shared/selectors/filters';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { PriceTypeContainer as ResidentialPriceTypeContainer } from './containers';
import { PriceTypeContainer as CommercialPriceTypeContainer } from 'shared/containers/PriceTypeContainer';
import { isCommercial } from '../../../packages/JsonQuery/category';
import { usePriceChangeHandler } from './hooks';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { trackQuickFilterClick } from 'shared/utils/analytics/trackQuickFiltersEvents';

export const PriceContainer: FC = () => {
  const {
    label,
    value: { min, max },
    size,
  } = useSelector(selectPriceFilter);
  const isPriceTypeAvailable = useSelector(selectPriceTypeAvailable);
  const offerType = useSelector(selectOfferType);
  const isCommercialOffer = isCommercial(offerType);

  const dropdownState = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const { onChangeMin, onChangeMax, showCorrectionHint } = usePriceChangeHandler();

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const handleOpen = useCallback(() => {
    trackQuickFilterClick('price');
    dropdownState.onOpen();
  }, [dropdownState]);

  const priceTypeFilter = isCommercialOffer ? (
    <CommercialPriceTypeContainer />
  ) : isPriceTypeAvailable ? (
    <ResidentialPriceTypeContainer />
  ) : null;

  return (
    <DropdownFilter
      {...dropdownState}
      onOpen={handleOpen}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <DropdownPrice
          valueMax={max}
          valueMin={min}
          priceTypeFilter={priceTypeFilter}
          showCorrectionHint={showCorrectionHint}
          onChangeMax={onChangeMax}
          onChangeMin={onChangeMin}
          isFiltersRedesignEnabled={isFiltersRedesignEnabled}
        />
      }
      size={size}
    />
  );
};
